import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';
import { ErrorToast } from '../../components/Toasts';
import { getErrorMessage } from './utils';
import './DropZone.css';
import * as S from './DropZone.css';
const DropZone = ({ children, onDropCallback, acceptFormats, maxSize, }) => {
    const onDrop = useCallback((acceptedFiles, rejectedFiles) => {
        var _a;
        if (!!(rejectedFiles === null || rejectedFiles === void 0 ? void 0 : rejectedFiles.length)) {
            const errorMessage = getErrorMessage((_a = rejectedFiles[0]) === null || _a === void 0 ? void 0 : _a.errors[0], // display first error from the list
            maxSize);
            toast.error(_jsx(ErrorToast, { message: errorMessage }), {
                autoClose: false,
            });
        }
        else {
            onDropCallback(acceptedFiles[0]);
        }
    }, [maxSize, onDropCallback]);
    const { getRootProps, isDragActive } = useDropzone({
        onDrop,
        accept: acceptFormats,
        multiple: false,
        maxSize: maxSize ? maxSize * 1000 : undefined, // in bytes
    });
    return (_jsx(S.DropZoneArea, Object.assign({}, getRootProps(), { className: isDragActive ? 'fileInDropArea' : undefined }, { children: children })));
};
export default memo(DropZone);
